import { render, staticRenderFns } from "./Modelos.vue?vue&type=template&id=68a6a04c"
import script from "./Modelos.vue?vue&type=script&lang=js"
export * from "./Modelos.vue?vue&type=script&lang=js"
import style0 from "./Modelos.vue?vue&type=style&index=0&id=68a6a04c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports